/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetInboxesResponseData,
  GetInboxesResponseDataFromJSON,
  GetInboxesResponseDataFromJSONTyped,
  GetInboxesResponseDataToJSON
} from './GetInboxesResponseData'

/**
 *
 * @export
 * @interface GetInboxesResponse
 */
export interface GetInboxesResponse {
  /**
   *
   * @type {number}
   * @memberof GetInboxesResponse
   */
  status?: number
  /**
   *
   * @type {GetInboxesResponseData}
   * @memberof GetInboxesResponse
   */
  data?: GetInboxesResponseData
}

export function GetInboxesResponseFromJSON(json: any): GetInboxesResponse {
  return GetInboxesResponseFromJSONTyped(json, false)
}

export function GetInboxesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetInboxesResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetInboxesResponseDataFromJSON(json['data'])
  }
}

export function GetInboxesResponseToJSON(value?: GetInboxesResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetInboxesResponseDataToJSON(value.data)
  }
}
